module.exports = __webpack_public_path__ + "img/marketing.1080d4cc.svg";